export interface IGetVehiclesFiltersDto {
    includeExternal?: boolean;
    includeSharedFinished?: boolean;
}
